'use client';

import { useTranslations } from 'next-intl';
import { SUPPORT_EMAIL } from '@/lib/supportEmail';

export function RegistrationRulesBody() {
  const t = useTranslations('legalDocs.registrationRules');
  return (
    <div className="prose prose-lg max-w-none">
      <h1 className="text-4xl font-bold text-fest-ink mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
        {t('h1')}
      </h1>
      <p className="text-sm text-fest-gold mb-6">{t('lead')}</p>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2General')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">{t('p1')}</p>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Requirements')}</h2>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('req1')}</li>
        <li>{t('req2')}</li>
        <li>{t('req3')}</li>
        <li>{t('req4')}</li>
      </ul>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2RegDetails')}</h2>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('regD1')}</li>
        <li>{t('regD2')}</li>
        <li>{t('regD3')}</li>
      </ul>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Process')}</h2>
      <ol className="list-decimal list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('proc1')}</li>
        <li>{t('proc2')}</li>
        <li>{t('proc3')}</li>
        <li>{t('proc4')}</li>
        <li>{t('proc5')}</li>
      </ol>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Accreditation')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">{t('pAccreditation')}</p>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('acc1')}</li>
        <li>{t('acc2')}</li>
        <li>{t('acc3')}</li>
        <li>{t('acc4')}</li>
      </ul>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Cancel')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">{t('pCancel')}</p>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Organizer')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">{t('pOrganizer')}</p>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('org1')}</li>
        <li>{t('org2')}</li>
        <li>{t('org3')}</li>
        <li>{t('org4')}</li>
      </ul>
    </div>
  );
}

export function PublicOfferBody() {
  const t = useTranslations('legalDocs.publicOffer');
  return (
    <div className="prose prose-lg max-w-none">
      <h1 className="text-4xl font-bold text-fest-ink mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
        {t('h1')}
      </h1>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('s1')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">{t('p1')}</p>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('s2')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">{t('p2')}</p>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('s3')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">{t('p3')}</p>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('s4')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">
        <strong>{t('organizerMust')}</strong>
      </p>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('om1')}</li>
        <li>{t('om2')}</li>
        <li>{t('om3')}</li>
      </ul>
      <p className="text-fest-muted-text leading-relaxed mb-4">
        <strong>{t('participantMust')}</strong>
      </p>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('pm1')}</li>
        <li>{t('pm2')}</li>
        <li>{t('pm3')}</li>
      </ul>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('s5')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">{t('p5')}</p>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Veedor')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">{t('pVeedor')}</p>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('vee1')}</li>
        <li>{t('vee2')}</li>
        <li>{t('vee3')}</li>
      </ul>
    </div>
  );
}

export function TermsOfUseBody() {
  const t = useTranslations('legalDocs.termsOfUse');
  return (
    <div className="prose prose-lg max-w-none">
      <h1 className="text-4xl font-bold text-fest-ink mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
        {t('h1')}
      </h1>
      <p className="text-fest-muted-text leading-relaxed mb-4">
        <em>{t('updated')}</em>
      </p>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('s1')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">{t('p1')}</p>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('s2')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">{t('p2')}</p>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('s3')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">{t('p3')}</p>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('s4')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">{t('p4')}</p>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('prize1')}</li>
        <li>{t('prize2')}</li>
        <li>{t('prize3')}</li>
      </ul>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Scoring')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">{t('pScoring')}</p>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Criteria')}</h2>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('crit1')}</li>
        <li>{t('crit2')}</li>
        <li>{t('crit3')}</li>
        <li>{t('crit4')}</li>
        <li>{t('crit5')}</li>
        <li>{t('crit6')}</li>
        <li>{t('crit7')}</li>
        <li>{t('crit8')}</li>
      </ul>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2CriteriaEsc')}</h2>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('critEsc1')}</li>
        <li>{t('critEsc2')}</li>
        <li>{t('critEsc3')}</li>
        <li>{t('critEsc4')}</li>
      </ul>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Formats')}</h2>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('fmtPista')}</li>
        <li>{t('fmtEsc')}</li>
        <li>{t('fmtVals')}</li>
        <li>{t('fmtMilonga')}</li>
        <li>{t('fmtMilonguero')}</li>
        <li>{t('fmtOrchestra')}</li>
      </ul>
    </div>
  );
}

export function PaymentRefundBody() {
  const t = useTranslations('legalDocs.paymentRefund');
  return (
    <div className="prose prose-lg max-w-none">
      <h1 className="text-4xl font-bold text-fest-ink mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
        {t('h1')}
      </h1>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Methods')}</h2>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('m1')}</li>
        <li>{t('m2')}</li>
        <li>{t('m3')}</li>
      </ul>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Refund')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">{t('pRefund')}</p>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Currency')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">{t('pCurrency')}</p>

      <h2 className="text-2xl font-bold text-fest-ink mt-10 mb-2">{t('h2RequisitesRu')}</h2>
      <p className="text-sm text-fest-muted-text italic mb-4">{t('reqRuNote')}</p>
      <div className="rounded-xl border border-fest-border bg-fest-surface p-6 text-sm not-prose">
        <p className="mb-4 font-bold text-fest-ink">{t('reqRuCompany')}</p>
        <div className="space-y-1.5 text-fest-muted-text">
          <div className="flex gap-2">
            <span className="w-44 flex-shrink-0 font-medium text-fest-ink">{t('reqRuInnLabel')}</span>
            <span>{t('reqRuInn')}</span>
          </div>
          <div className="flex gap-2">
            <span className="w-44 flex-shrink-0 font-medium text-fest-ink">{t('reqRuKppLabel')}</span>
            <span>{t('reqRuKpp')}</span>
          </div>
          <div className="flex gap-2">
            <span className="w-44 flex-shrink-0 font-medium text-fest-ink">{t('reqRuOgrnLabel')}</span>
            <span>{t('reqRuOgrn')}</span>
          </div>
          <div className="flex gap-2">
            <span className="w-44 flex-shrink-0 font-medium text-fest-ink">{t('reqRuAddressLabel')}</span>
            <span>{t('reqRuAddress')}</span>
          </div>
          <div className="flex gap-2">
            <span className="w-44 flex-shrink-0 font-medium text-fest-ink">{t('reqRuDirectorLabel')}</span>
            <span>{t('reqRuDirector')}</span>
          </div>
        </div>
        <div className="my-4 border-t border-fest-border" />
        <div className="space-y-1.5 text-fest-muted-text">
          <div className="flex gap-2">
            <span className="w-44 flex-shrink-0 font-medium text-fest-ink">{t('reqRuBankLabel')}</span>
            <span>{t('reqRuBank')}</span>
          </div>
          <div className="flex gap-2">
            <span className="w-44 flex-shrink-0 font-medium text-fest-ink">{t('reqRuAccountLabel')}</span>
            <span className="font-mono tracking-wide">{t('reqRuAccount')}</span>
          </div>
          <div className="flex gap-2">
            <span className="w-44 flex-shrink-0 font-medium text-fest-ink">{t('reqRuBikLabel')}</span>
            <span className="font-mono tracking-wide">{t('reqRuBik')}</span>
          </div>
          <div className="flex gap-2">
            <span className="w-44 flex-shrink-0 font-medium text-fest-ink">{t('reqRuKorrLabel')}</span>
            <span className="font-mono tracking-wide">{t('reqRuKorr')}</span>
          </div>
        </div>
        <div className="my-4 border-t border-fest-border" />
        <div className="space-y-1.5 text-fest-muted-text">
          <div className="flex gap-2">
            <span className="w-44 flex-shrink-0 font-medium text-fest-ink">{t('reqRuPhoneLabel')}</span>
            <span>{t('reqRuPhone')}</span>
          </div>
          <div className="flex gap-2">
            <span className="w-44 flex-shrink-0 font-medium text-fest-ink">{t('reqRuEmailLabel')}</span>
            <span>{t('reqRuEmail')}</span>
          </div>
        </div>
      </div>

      <h2 className="text-2xl font-bold text-fest-ink mt-10 mb-2">{t('h2RequisitesInt')}</h2>
      <p className="text-sm text-fest-muted-text italic mb-4">{t('reqIntNote')}</p>
      <div className="rounded-xl border border-fest-border bg-fest-surface p-6 text-sm not-prose">
        <p className="mb-4 font-bold text-fest-ink">{t('reqIntCompany')}</p>
        <div className="space-y-1.5 text-fest-muted-text">
          <div className="flex gap-2">
            <span className="w-44 flex-shrink-0 font-medium text-fest-ink">{t('reqIntAddressLabel')}</span>
            <span>{t('reqIntAddress')}</span>
          </div>
          <div className="flex gap-2">
            <span className="w-44 flex-shrink-0 font-medium text-fest-ink">{t('reqIntVoenLabel')}</span>
            <span className="font-mono tracking-wide">{t('reqIntVoen')}</span>
          </div>
        </div>
        <div className="my-4 border-t border-fest-border" />
        <div className="space-y-1.5 text-fest-muted-text">
          <div className="flex gap-2">
            <span className="w-44 flex-shrink-0 font-medium text-fest-ink">{t('reqIntBankLabel')}</span>
            <span>{t('reqIntBank')}</span>
          </div>
          <div className="flex gap-2">
            <span className="w-44 flex-shrink-0 font-medium text-fest-ink">{t('reqIntBankCodeLabel')}</span>
            <span className="font-mono tracking-wide">{t('reqIntBankCode')}</span>
          </div>
          <div className="flex gap-2">
            <span className="w-44 flex-shrink-0 font-medium text-fest-ink">{t('reqIntBankVoenLabel')}</span>
            <span className="font-mono tracking-wide">{t('reqIntBankVoen')}</span>
          </div>
          <div className="flex gap-2">
            <span className="w-44 flex-shrink-0 font-medium text-fest-ink">{t('reqIntSwiftLabel')}</span>
            <span className="font-mono tracking-wide">{t('reqIntSwift')}</span>
          </div>
          <div className="flex gap-2">
            <span className="w-44 flex-shrink-0 font-medium text-fest-ink">{t('reqIntCorrAccountLabel')}</span>
            <span className="font-mono tracking-wide break-all">{t('reqIntCorrAccount')}</span>
          </div>
          <div className="flex gap-2">
            <span className="w-44 flex-shrink-0 font-medium text-fest-ink">{t('reqIntIbanLabel')}</span>
            <span className="font-mono tracking-wide break-all">{t('reqIntIban')}</span>
          </div>
        </div>
        <div className="my-4 border-t border-fest-border" />
        <div className="space-y-1.5 text-fest-muted-text">
          <div className="flex gap-2">
            <span className="w-44 flex-shrink-0 font-medium text-fest-ink">{t('reqIntSignatoryLabel')}</span>
            <span>{t('reqIntSignatory')}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export function PrivacyPolicyBody() {
  const t = useTranslations('legalDocs.privacyPolicy');
  return (
    <div className="prose prose-lg max-w-none">
      <h1 className="text-4xl font-bold text-fest-ink mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
        {t('h1')}
      </h1>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Collect')}</h2>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('c1')}</li>
        <li>{t('c2')}</li>
        <li>{t('c3')}</li>
      </ul>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Use')}</h2>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('u1')}</li>
        <li>{t('u2')}</li>
        <li>{t('u3')}</li>
      </ul>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Rights')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">{t('pRights')}</p>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Inquiries')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">
        {t('pInquiriesLead')}{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`} className="text-fest-gold hover:underline">
          {SUPPORT_EMAIL}
        </a>
      </p>
    </div>
  );
}

export function LiabilityWaiverBody() {
  const t = useTranslations('legalDocs.liabilityWaiver');
  return (
    <div className="prose prose-lg max-w-none">
      <h1 className="text-4xl font-bold text-fest-ink mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
        {t('h1')}
      </h1>
      <div className="bg-yellow-50 border-2 border-yellow-400 p-6 rounded-lg mb-6 not-prose">
        <p className="text-fest-ink font-bold">{t('warning')}</p>
      </div>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Conduct')}</h2>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('conduct1')}</li>
        <li>{t('conduct2')}</li>
        <li>{t('conduct3')}</li>
        <li>{t('conduct4')}</li>
      </ul>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Risk')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">{t('pRisk')}</p>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Release')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">{t('pRelease')}</p>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2DressCode')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-2">{t('pDressCode')}</p>
      <p className="text-sm text-fest-muted-text italic mb-4">{t('pDressCodeNote')}</p>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 not-prose mb-6">
        <div className="rounded-xl border border-fest-border bg-fest-surface p-4">
          <p className="mb-2 font-semibold text-fest-ink text-sm">{t('dressMenLabel')}</p>
          <ul className="space-y-1 text-sm text-fest-muted-text">
            <li>✓ {t('dressMen1')}</li>
            <li>✓ {t('dressMen2')}</li>
            <li>✓ {t('dressMen3')}</li>
          </ul>
        </div>
        <div className="rounded-xl border border-fest-border bg-fest-surface p-4">
          <p className="mb-2 font-semibold text-fest-ink text-sm">{t('dressWomenLabel')}</p>
          <ul className="space-y-1 text-sm text-fest-muted-text">
            <li>✓ {t('dressWomen1')}</li>
            <li>✓ {t('dressWomen2')}</li>
          </ul>
        </div>
      </div>
      <div className="rounded-xl border-2 border-red-200 bg-red-50 p-4 not-prose mb-6">
        <p className="mb-2 font-semibold text-red-700 text-sm">{t('dressBannedLabel')}</p>
        <ul className="space-y-1 text-sm text-red-600">
          <li>✕ {t('dressBanned1')}</li>
          <li>✕ {t('dressBanned2')}</li>
          <li>✕ {t('dressBanned3')}</li>
        </ul>
      </div>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Ack')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">{t('pAck')}</p>
    </div>
  );
}

export function InternationalClauseBody() {
  const t = useTranslations('legalDocs.internationalClause');
  return (
    <div className="prose prose-lg max-w-none">
      {/* Official document banner */}
      <div className="not-prose mb-8 rounded-xl border-2 border-fest-gold bg-gradient-to-r from-amber-50 to-yellow-50 px-6 py-5">
        <p className="text-sm font-semibold uppercase tracking-widest text-amber-700 mb-1">
          {t('bannerTitle')}
        </p>
        <p className="text-xs text-amber-600">{t('bannerSubtitle')}</p>
      </div>

      <h1 className="text-4xl font-bold text-fest-ink mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
        {t('h1')}
      </h1>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Circuit')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">{t('pCircuit')}</p>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Categories')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-3">{t('pCategories')}</p>
      <ul className="list-disc list-inside space-y-1 text-fest-muted-text mb-3">
        <li>{t('cat1')}</li>
        <li>{t('cat2')}</li>
        <li>{t('cat3')}</li>
        <li>{t('cat4')}</li>
        <li>{t('cat5')}</li>
      </ul>
      <p className="text-sm text-fest-muted-text italic mb-4">{t('catNote')}</p>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2OfficialCategories')}</h2>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('catPista')}</li>
        <li>{t('catMilongueros')}</li>
        <li>{t('catVals')}</li>
        <li>{t('catMilonga')}</li>
        <li>{t('catEscenario')}</li>
      </ul>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Registration')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-3">{t('pRegistrationAge')}</p>
      <p className="text-fest-muted-text leading-relaxed mb-2">
        <strong className="text-fest-ink">{t('regNationalTitle')}</strong>{' '}
        {t('regNational')}
      </p>
      <p className="text-fest-muted-text leading-relaxed mb-4">
        <strong className="text-fest-ink">{t('regIntlTitle')}</strong>{' '}
        {t('regIntl')}
      </p>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Accreditation')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">{t('pAccreditation')}</p>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Stages')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-3">{t('pStages')}</p>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-3">
        <li>{t('stage1')}</li>
        <li>{t('stage2')}</li>
        <li>{t('stage3')}</li>
      </ul>
      <p className="text-fest-muted-text leading-relaxed mb-3">{t('stageRondas')}</p>
      <p className="text-sm text-fest-muted-text italic mb-4">{t('stageNote')}</p>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Judging')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-3">{t('pJudging')}</p>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('judging1')}</li>
        <li>{t('judging2')}</li>
        <li>{t('judging3')}</li>
        <li>{t('judging4')}</li>
        <li>{t('judging5')}</li>
      </ul>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Scoring')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-3">{t('pScoring')}</p>
      <p className="text-sm text-fest-muted-text italic mb-4">{t('pScoringExample')}</p>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2CriteriaPista')}</h2>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('critPista1')}</li>
        <li>{t('critPista2')}</li>
        <li>{t('critPista3')}</li>
        <li>{t('critPista4')}</li>
        <li>{t('critPista5')}</li>
        <li>{t('critPista6')}</li>
        <li>{t('critPista7')}</li>
      </ul>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2CriteriaEsc')}</h2>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('critEsc1')}</li>
        <li>{t('critEsc2')}</li>
        <li>{t('critEsc3')}</li>
        <li>{t('critEsc4')}</li>
      </ul>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Organizer')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">{t('pOrganizer')}</p>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Veedor')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-3">{t('pVeedor')}</p>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('vee1')}</li>
        <li>{t('vee2')}</li>
        <li>{t('vee3')}</li>
      </ul>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Contact')}</h2>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('e1')}</li>
        <li>
          <span className="font-medium text-fest-ink">{t('e3Label')}: </span>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="text-fest-gold hover:underline">
            {SUPPORT_EMAIL}
          </a>
        </li>
        <li>{t('e2')}</li>
      </ul>
    </div>
  );
}

export function ChampionshipRulesBody() {
  const t = useTranslations('legalDocs.championshipRules');
  return (
    <div className="prose prose-lg max-w-none">
      {/* Banner */}
      <div className="not-prose mb-8 rounded-xl border-2 border-fest-gold bg-gradient-to-r from-amber-50 to-yellow-50 px-6 py-5">
        <p className="text-sm font-semibold uppercase tracking-widest text-amber-700 mb-1">
          {t('subtitle')}
        </p>
        <p className="text-xs text-amber-600">{t('subtitleDesc')}</p>
      </div>

      <h1 className="text-4xl font-bold text-fest-ink mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
        {t('h1')}
      </h1>
      <p className="text-fest-muted-text leading-relaxed mb-2">
        {t('p1')}
      </p>
      <p className="text-fest-muted-text leading-relaxed mb-6">
        {t('p2')}
      </p>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Organization')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-3">
        {t('orgP1')}
      </p>
      <p className="text-fest-muted-text leading-relaxed mb-2 font-medium">{t('orgJudges')}</p>
      <ul className="list-disc list-inside space-y-1 text-fest-muted-text mb-4">
        <li>{t('judge1')}</li>
        <li>{t('judge2')}</li>
        <li>{t('judge3')}</li>
        <li>{t('judge4')}</li>
        <li>{t('judge5')}</li>
        <li>{t('judge6')}</li>
        <li>{t('judge7')}</li>
      </ul>
      <p className="text-sm text-fest-muted-text italic mb-4">
        {t('orgP2')}
      </p>

      <div className="not-prose bg-yellow-50 border-2 border-yellow-400 p-6 rounded-lg mb-6">
        <p className="text-fest-ink font-bold">
          {t('important')}
        </p>
      </div>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Categories')}</h2>
      <ol className="list-decimal list-inside space-y-1 text-fest-muted-text mb-3">
        <li>{t('cat1')}</li>
        <li>{t('cat2')}</li>
        <li>{t('cat3')}</li>
        <li>{t('cat4')}</li>
      </ol>
      <p className="text-sm text-fest-muted-text italic mb-4">
        {t('catNote')}
      </p>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2RegRules')}</h2>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('reg1')}</li>
        <li>{t('reg2')}</li>
        <li>{t('reg3')}</li>
        <li>{t('reg4')}</li>
      </ul>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Conduct')}</h2>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-3">
        <li>{t('con1')}</li>
        <li>{t('con2')}</li>
        <li>{t('con3')}</li>
        <li>{t('con4')}</li>
      </ul>
      <p className="text-fest-muted-text leading-relaxed mb-2">{t('conP1')}</p>
      <ul className="list-disc list-inside space-y-1 text-fest-muted-text mb-4">
        <li>{t('disq1')}</li>
        <li>{t('disq2')}</li>
        <li>{t('disq3')}</li>
        <li>{t('disq4')}</li>
        <li>{t('disq5')}</li>
        <li>{t('disq6')}</li>
      </ul>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Format')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-3">{t('formP1')}</p>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li dangerouslySetInnerHTML={{ __html: t('form1') }} />
        <li dangerouslySetInnerHTML={{ __html: t('form2') }} />
        <li dangerouslySetInnerHTML={{ __html: t('form3') }} />
        <li dangerouslySetInnerHTML={{ __html: t('form4') }} />
        <li dangerouslySetInnerHTML={{ __html: t('form5') }} />
      </ul>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Judging')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-3">
        {t('judgingP1')}
      </p>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2CriteriaPista')}</h2>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('crit1')}</li>
        <li>{t('crit2')}</li>
        <li>{t('crit3')}</li>
        <li>{t('crit4')}</li>
        <li>{t('crit5')}</li>
        <li>{t('crit6')}</li>
        <li>{t('crit7')}</li>
      </ul>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2CriteriaEscenario')}</h2>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('esc1')}</li>
        <li>{t('esc2')}</li>
        <li>{t('esc3')}</li>
        <li>{t('esc4')}</li>
      </ul>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2DressCode')}</h2>
      <div className="not-prose grid grid-cols-1 gap-4 sm:grid-cols-2 mb-4">
        <div className="rounded-xl border border-fest-border bg-fest-surface p-4">
          <p className="mb-2 font-semibold text-fest-ink text-sm">{t('dressMen')}</p>
          <ul className="space-y-1 text-sm text-fest-muted-text">
            <li>{t('dressMen1')}</li>
            <li>{t('dressMen2')}</li>
            <li>{t('dressMen3')}</li>
          </ul>
        </div>
        <div className="rounded-xl border border-fest-border bg-fest-surface p-4">
          <p className="mb-2 font-semibold text-fest-ink text-sm">{t('dressWomen')}</p>
          <ul className="space-y-1 text-sm text-fest-muted-text">
            <li>{t('dressWomen1')}</li>
            <li>{t('dressWomen2')}</li>
          </ul>
        </div>
      </div>
      <div className="not-prose rounded-xl border-2 border-red-200 bg-red-50 p-4 mb-6">
        <p className="mb-2 font-semibold text-red-700 text-sm">{t('dressProhibited')}</p>
        <ul className="space-y-1 text-sm text-red-600">
          <li>{t('dressProh1')}</li>
          <li>{t('dressProh2')}</li>
          <li>{t('dressProh3')}</li>
        </ul>
      </div>

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Fees')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-3" dangerouslySetInnerHTML={{ __html: t('feesP1') }} />

      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Ack')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">
        {t('ackP1')}
      </p>
    </div>
  );
}

export function FestivalChampionshipRulesBody() {
  const t = useTranslations('legalDocs.festivalChampionshipRules');
  return (
    <div className="prose prose-lg max-w-none">
      {/* Banner */}
      <div className="not-prose mb-8 rounded-xl border-2 border-fest-gold bg-gradient-to-r from-amber-50 to-yellow-50 px-6 py-5">
        <p className="text-sm font-semibold uppercase tracking-widest text-amber-700 mb-1">
          El Calor en Baku 2026 · Baku Tango Trophy 2026
        </p>
        <p className="text-xs text-amber-600">{t('intro3')} · {t('intro4')}</p>
      </div>

      <h1 className="text-4xl font-bold text-fest-ink mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
        {t('h1')}
      </h1>

      <p className="text-fest-muted-text leading-relaxed mb-1">{t('intro1')}</p>
      <p className="text-fest-muted-text leading-relaxed mb-1">{t('intro2')}</p>
      <p className="text-fest-muted-text leading-relaxed mb-1">{t('intro5')}</p>
      <p className="text-fest-muted-text leading-relaxed mb-6">{t('intro6')}</p>

      {/* Organization */}
      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Org')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-3">{t('orgP1')}</p>
      <p className="text-fest-muted-text mb-2">
        {t('orgSkatingLabel')}{' '}
        <a href={t('orgSkatingUrl')} target="_blank" rel="noopener noreferrer" className="text-fest-gold hover:underline break-all">
          {t('orgSkatingUrl')}
        </a>
      </p>
      <p className="text-fest-muted-text leading-relaxed mb-2 font-medium">{t('orgJudgesLabel')}</p>
      <ul className="list-disc list-inside space-y-1 text-fest-muted-text mb-3">
        <li>{t('judge1')}</li>
        <li>{t('judge2')}</li>
        <li>{t('judge3')}</li>
        <li>{t('judge4')}</li>
        <li>{t('judge5')}</li>
        <li>{t('judge6')}</li>
        <li>{t('judge7')}</li>
      </ul>
      <p className="text-sm text-fest-muted-text italic mb-4">{t('orgAddSpec')}</p>

      {/* Masters of Musicality */}
      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Masters')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-2">{t('mastersP1')}</p>
      <ul className="list-disc list-inside space-y-1 text-fest-muted-text mb-4">
        <li>{t('mastersCat1')}</li>
        <li>{t('mastersCat2')}</li>
        <li>{t('mastersCat3')}</li>
        <li>{t('mastersCat4')}</li>
      </ul>

      {/* Judging Panel */}
      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Panel')}</h2>
      <p className="text-fest-muted-text mb-2">{t('panelIntro')}</p>
      <ul className="list-disc list-inside space-y-1 text-fest-muted-text mb-4">
        <li>{t('panel1')}</li>
        <li>{t('panel2')}</li>
        <li>{t('panel3')}</li>
        <li>{t('panel4')}</li>
        <li>{t('panel5')}</li>
      </ul>

      <div className="not-prose bg-yellow-50 border-2 border-yellow-400 p-5 rounded-lg mb-4">
        <p className="text-fest-ink font-bold text-sm">{t('important1')}</p>
      </div>
      <div className="not-prose bg-blue-50 border border-blue-200 p-4 rounded-lg mb-6">
        <p className="text-blue-800 text-sm">{t('privacyP')}</p>
      </div>

      {/* Categories */}
      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Categories')}</h2>
      <ol className="list-decimal list-inside space-y-1 text-fest-muted-text mb-2">
        <li>{t('cat1')}</li>
        <li>
          {t('cat2')}
          <ul className="list-disc list-inside ml-6 mt-1 space-y-1">
            <li>{t('cat2a')}</li>
            <li>{t('cat2b')}</li>
            <li>{t('cat2c')}</li>
            <li>{t('cat2d')}</li>
          </ul>
        </li>
        <li>{t('cat3')}</li>
        <li>{t('cat4')}</li>
      </ol>
      <p className="text-sm text-fest-muted-text italic mb-4">{t('catNote')}</p>

      {/* Registration */}
      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2RegRules')}</h2>
      <h3 className="text-lg font-semibold text-fest-ink mb-3">{t('h3Reg')}</h3>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('reg1')}</li>
        <li>{t('reg2')}</li>
        <li>{t('reg3')}</li>
        <li>{t('reg4')}</li>
        <li>{t('reg5')}</li>
        <li>{t('reg6')}</li>
      </ul>

      {/* Conduct */}
      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Conduct')}</h2>
      <p className="text-fest-muted-text mb-2">{t('conductIntro')}</p>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('conduct1')}</li>
        <li>{t('conduct2')}</li>
        <li>{t('conduct3')}</li>
        <li>{t('conduct4')}</li>
      </ul>

      {/* Sanctions */}
      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Sanctions')}</h2>
      <p className="text-fest-muted-text mb-2">{t('sanctP1')}</p>
      <ul className="list-disc list-inside space-y-1 text-fest-muted-text mb-4">
        <li>{t('sanct1')}</li>
        <li>{t('sanct2')}</li>
        <li>{t('sanct3')}</li>
        <li>{t('sanct4')}</li>
        <li>{t('sanct5')}</li>
        <li>{t('sanct6')}</li>
      </ul>

      {/* Competition Format */}
      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Competition')}</h2>
      <p className="text-fest-muted-text mb-2">{t('compP1')}</p>
      <ul className="list-disc list-inside space-y-1 text-fest-muted-text mb-3">
        <li>{t('compStage1Desc')}</li>
        <li>{t('compStage2Desc')}</li>
        <li>{t('compStage3Desc')}</li>
      </ul>
      <p className="text-sm text-fest-muted-text italic mb-3">{t('compNote')}</p>
      <ul className="list-disc list-inside space-y-2 text-fest-muted-text mb-4">
        <li>{t('compPista')}</li>
        <li>{t('compEsc')}</li>
        <li>{t('compVals')}</li>
        <li>{t('compMilonga')}</li>
        <li>{t('compMilonguero')}</li>
        <li>{t('compOrchestra')}</li>
      </ul>

      {/* Judging */}
      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Judging')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">{t('judgingP1')}</p>

      {/* Criteria */}
      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Criteria')}</h2>
      <div className="space-y-4 mb-4">
        <p className="text-fest-muted-text leading-relaxed">{t('critPistaP1')}</p>
        <p className="text-fest-muted-text leading-relaxed">{t('critEscP1')}</p>
        <p className="text-fest-muted-text leading-relaxed">{t('critMilongueroP1')}</p>
        <p className="text-fest-muted-text leading-relaxed">{t('critValsP1')}</p>
        <p className="text-fest-muted-text leading-relaxed">{t('critMilongaP1')}</p>
        <p className="text-fest-muted-text leading-relaxed">{t('critOrchestraP1')}</p>
      </div>

      {/* Costume */}
      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Costume')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-3">{t('costumeP1')}</p>
      <div className="not-prose grid grid-cols-1 gap-4 sm:grid-cols-2 mb-4">
        <div className="rounded-xl border border-fest-border bg-fest-surface p-4">
          <p className="mb-2 font-semibold text-fest-ink text-sm">{t('costumeMenLabel')}</p>
          <p className="text-sm text-fest-muted-text">{t('costumeMen')}</p>
        </div>
        <div className="rounded-xl border border-fest-border bg-fest-surface p-4">
          <p className="mb-2 font-semibold text-fest-ink text-sm">{t('costumeWomenLabel')}</p>
          <p className="text-sm text-fest-muted-text">{t('costumeWomen')}</p>
        </div>
      </div>
      <div className="not-prose rounded-xl border-2 border-red-200 bg-red-50 p-4 mb-3">
        <p className="mb-1 font-semibold text-red-700 text-sm">{t('costumeProhibitedLabel')}</p>
        <p className="text-sm text-red-600 mb-1">{t('costumeMenProhibited')}</p>
        <p className="text-sm text-red-600">{t('costumeWomenProhibited')}</p>
      </div>
      <div className="not-prose bg-yellow-50 border border-yellow-300 p-3 rounded-lg mb-6">
        <p className="text-amber-800 text-sm font-semibold">{t('costumeImportant')}</p>
      </div>

      {/* Photo */}
      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Photo')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-4">{t('photoP1')}</p>

      {/* Fees */}
      <h2 className="text-2xl font-bold text-fest-ink mt-8 mb-4">{t('h2Fees')}</h2>
      <p className="text-fest-muted-text leading-relaxed mb-2">{t('feesP1')}</p>
      <p className="text-fest-muted-text leading-relaxed mb-2">{t('feesP2')}</p>
      <p className="text-fest-muted-text leading-relaxed mb-4">{t('feesP3')}</p>
    </div>
  );
}
